import { z } from 'zod';
export const NetworkInsightsStatusEnum = z.enum([
    'clear',
    'off_boarding_reported',
    'high_risk_off_boarding_reported'
]);
export const NetworkInsightsSchema = z.object({
    status: NetworkInsightsStatusEnum,
    reportDate: z.string().nullish(),
    reason: z.string().nullish()
}).nullish().meta({
    id: 'NetworkInsights'
});

//# sourceMappingURL=network-insights.schema.js.map